import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Spinner,
  Wrapper,
  Card,
  Copy,
  Bold,
  Row
} from "app/NativeComponents/common";
import {
  GhostButton,
  SelectItem,
  InlineButton
} from "app/NativeComponents/snippets";

import { Header1, Header3 } from "app/NativeComponents/common";

import QuestionSelect from "app/DealMachineCore/MarketingOnboardingAndFunnel/GlobalSnippets/QuestionSelect";

import {
  numberWithCommas,
  startRedirect,
  tabNavigation,
  updateUser,
  toggleChurnBuster
} from "app/NativeActions";
class HowDidWeFallShort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_options: []
    };
  }

  componentDidMount() {
    if (this.props.device == "desktop") {
      this.props.startRedirect("/cancel/how-did-we-fall-short");
    }
  }

  addOrRemoveOption(slug) {
    const { selected_options } = this.state;
    if (selected_options.includes(slug)) {
      this.setState({
        selected_options: selected_options.filter(option => option !== slug)
      });
    } else {
      this.setState({
        selected_options: [...selected_options, slug]
      });
    }
  }

  render() {
    const { colors, user } = this.props;
    if (this.props.init && this.props.user) {
    } else if (this.props.loading) {
      return <Spinner />;
    }

    return (
      <>
        <Wrapper
          style={{
            alignItems: "center",
            justifyContent: "center",
            padding: 25
          }}
        >
          <Header1
            style={{
              textAlign: "center"
            }}
          >
            <Bold>👋 We're sorry to see you go. How did we fall short?</Bold>
          </Header1>
          <Wrapper style={{ padding: 25, paddingBottom: 0 }}>
            <Copy
              style={{
                textAlign: "center"
              }}
            >
              Select all that apply and click continue.
            </Copy>
          </Wrapper>
        </Wrapper>

        <Wrapper
          style={{
            width: "100%",
            margin: this.props.device == "desktop" ? "5px auto" : 0,
            alignSelf: "stretch"
          }}
        >
          <Wrapper
            style={{
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "stretch"
            }}
          >
            <Row
              style={
                this.props.device == "mobile"
                  ? {
                      padding: 10,
                      alignSelf: "stretch",
                      flexDirection: "column"
                    }
                  : this.props.desktopMobile
                  ? {
                      padding: 10,
                      alignSelf: "stretch",
                      flexDirection: "column"
                    }
                  : {
                      flexWrap: "wrap",
                      padding: 25,
                      justifyContent: "center"
                    }
              }
            >
              <QuestionSelect
                slug={"I need to learn more about real estate first"}
                selected_options={this.state.selected_options}
                onPress={() =>
                  this.addOrRemoveOption(
                    "I need to learn more about real estate first"
                  )
                }
                title={"I need to learn more about real estate first"}
                select_type={"check"}
              />
              <QuestionSelect
                slug={"I don't have the budget right now"}
                selected_options={this.state.selected_options}
                onPress={() =>
                  this.addOrRemoveOption("I don't have the budget right now")
                }
                title={"I don't have the budget right now"}
                select_type={"check"}
              />
              <QuestionSelect
                slug={"Not useful right now"}
                selected_options={this.state.selected_options}
                onPress={() => this.addOrRemoveOption("Not useful right now")}
                title={"Not useful right now"}
                select_type={"check"}
              />
              <QuestionSelect
                slug={"Poor support"}
                selected_options={this.state.selected_options}
                onPress={() => this.addOrRemoveOption("Poor support")}
                title={"Poor support"}
                select_type={"check"}
              />
              <QuestionSelect
                slug={"Missing features/hard to use"}
                selected_options={this.state.selected_options}
                onPress={() =>
                  this.addOrRemoveOption("Missing features/hard to use")
                }
                title={"Missing features/hard to use"}
                select_type={"check"}
                onPress={() =>
                  this.addOrRemoveOption("Missing features/hard to use")
                }
                loading={this.props.next_step_loading}
              />
              <QuestionSelect
                slug={"Other"}
                selected_options={this.state.selected_options}
                onPress={() => this.addOrRemoveOption("Other")}
                title={"Other"}
                select_type={"check"}
              />
            </Row>
            <GhostButton
              primary={true}
              button_type={"full"}
              buttonContainerStyle={
                this.props.desktopMobile ? { alignSelf: "stretch" } : {}
              }
              disabled={!this.state.selected_options.length > 0}
              icon_right={"arrow-right-alt"}
              onPress={() => {
                this.props.submitAnswer({
                  property_slug: "how_did_we_fall_short",
                  property_value: this.state.selected_options?.join(";")
                });
                this.props.nextStep();
              }}
            >
              Continue
            </GhostButton>
            <InlineButton
              button_type={"full"}
              buttonContainerStyle={
                this.props.desktopMobile ? { alignSelf: "stretch" } : {}
              }
              onPress={() => {
                this.props.tabNavigation({ slug: "leads" });
                this.props.toggleChurnBuster(false);
              }}
            >
              Nevermind, I don't want to cancel.
            </InlineButton>
            <Wrapper style={{ height: 40 }} />
          </Wrapper>
        </Wrapper>
      </>
    );
  }
}

const mapStateToProps = ({ auth, settings, native }) => {
  const { token, user, init, loading } = auth;

  const { colors } = settings;
  const { isMobile, device, initialRedirect, desktopMobile } = native;

  return {
    token,
    user,
    init,
    loading,
    colors,
    isMobile,
    device,
    initialRedirect,
    desktopMobile
  };
};

export default connect(mapStateToProps, {
  startRedirect,
  tabNavigation,
  updateUser,
  toggleChurnBuster
})(HowDidWeFallShort);
